module.exports = __webpack_public_path__ + "static/phone.ed53ca7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/phone.svg
// module id = 237
// module chunks = 35783957827783 95715928098905 172322841747965